import React, {ReactNode, useCallback } from "react";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";

export default function ListContext({children = null, handleSubmit, handleReset }: {children?: ReactNode | null, handleSubmit: ()=>void, handleReset: ()=>void } ) {
    const handleFormSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        event.stopPropagation();
        handleSubmit();
    }, [handleSubmit]);

    const handleFormReset =  useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        event.stopPropagation();
        handleReset();
    }, [handleReset]);

    if (!children) {
        return null;
    }
    
    return (
        <section className="list-context">
            <Form className="form" onSubmit={handleFormSubmit}>
                <div className="form-criteria">
                    {children}
                </div>
                <div className="form-actions">
                    <Button variant="secondary" className="btn-md btn-form-reset" tabIndex={5} title="Remise à zéro" onClick={handleFormReset}>
                        <span className="icon"></span>
                        <span className="text">RAZ</span>
                    </Button>
                    <Button type="submit" variant="primary" className="btn-md btn-form-submit" tabIndex={4} title="Appliquer">
                        <span className="icon"></span><span className="text">Appliquer</span>
                    </Button>
                </div>
            </Form>
        </section>
    );
}